import React, { useState, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react';
import { Type, Heading1, Heading2, Heading3, List, ListOrdered, CheckSquare, Quote, GripVertical } from 'lucide-react';

export const SlashMenu = forwardRef((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    const selectItem = useCallback((index) => {
        const item = props.items[index];
        if (item) {
            props.command(item);
        }
    }, [props]);

    useEffect(() => {
        setSelectedIndex(0);
    }, [props.items]);

    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
                return true;
            }
            if (event.key === 'ArrowDown') {
                setSelectedIndex((selectedIndex + 1) % props.items.length);
                return true;
            }
            if (event.key === 'Enter') {
                selectItem(selectedIndex);
                return true;
            }
            return false;
        },
    }));

    return (
        <div className="bg-white rounded-lg shadow-xl border border-slate-200 w-72 max-h-80 overflow-y-auto flex flex-col p-1 animate-in fade-in zoom-in-95 duration-100">
            <div className="text-xs font-bold text-slate-400 uppercase tracking-wider px-3 py-2">Basic blocks</div>
            {props.items.length ? (
                props.items.map((item, index) => (
                    <button
                        className={`text-left px-3 py-2 rounded-md flex items-center gap-3 transition-colors ${index === selectedIndex ? 'bg-indigo-50 text-indigo-900' : 'hover:bg-slate-50 text-slate-700'}`}
                        key={index}
                        onClick={() => selectItem(index)}
                    >
                        <div className={`p-1 rounded bg-white border border-slate-200 shadow-sm ${index === selectedIndex ? 'text-indigo-600 border-indigo-200' : 'text-slate-500'}`}>
                            {item.icon}
                        </div>
                        <div>
                            <div className="text-sm font-semibold">{item.title}</div>
                            {/* Description if added later */}
                        </div>
                    </button>
                ))
            ) : (
                <div className="px-3 py-2 text-sm text-slate-500">No result</div>
            )}
        </div>
    );
});
